import './Footer.css';
import logo from '../../images/logotip.png'
import phone from '../../images/icons8-телефон-100.png'
import email from '../../images/icons8-почта-100.png'
import geo from '../../images/icons8-маркер-100.png'
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Первый столбец */}
                <div className="footer-column">
                    <h3 className="footer-title"><img src={logo} alt="" />МБОУ СШ №6 г. Павлово</h3>
                    <ul className="footer-list">
                        <li><a href="#">Современный подход к знакомству
                        со школой</a></li>
                    </ul>
                </div>

                {/* Второй столбец */}
                <div className="footer-column">
                    <h3 className="footer-title">Навигация</h3>
                    <ul className="footer-list">
                        <li><Link to={'/'}>Главная</Link></li>
                        <li><Link to={'/Choose_floor'}>Экскурсия</Link></li>
                        <li><Link to={'/About_school'}>История школы</Link></li>
                        <li><Link to={'/Contacts'}>Контакты</Link></li>
                    </ul>
                </div>

                {/* Третий столбец */}
                <div className="footer-column">
                    <h3 className="footer-title">Контакты</h3>
                    <ul className="footer-list">
                        <li><a href="#"><img src={phone} alt="" />8(83171)2-10-45 <br/>8(83171)2-10-44</a></li>
                        <li><a href="#"><img src={email} alt="" />s6_pvl@mail.52gov.ru</a></li>
                        <li><a href="#"><img src={geo} alt="" />Нижегородская обл., Павловский муниципальный округ, <br/>г. Павлово, ул. Маяковского, 4</a></li>
                    </ul>
                </div>

                {/* Четвертый столбец */}
                <div className="footer-column">
                    <h3 className="footer-title">Социальные сети</h3>
                    <ul className="footer-list2">
                        <li><a href="https://vk.com/public164711425">Вконтакте</a></li>
                        <li><a href="https://www.school6pav.ru/">Сайт школы</a></li>
                    </ul>
                </div>
            </div>

            {/* Нижняя часть футера */}
            <div className="footer-bottom">
                <p>2025 Виртуальная школа.</p>
                <p>Часть фотографий взята из открытых источников</p>
                <p>Designed & developed by Vladimir Barinov</p>
            </div>
        </footer>
    );
}

export default Footer;